import { Stack, Typography } from "@mui/material"
import { ImageZoom } from "components/UI"
import SoundButton from "components/Activity/SoundButton"
import { masterBreakPoint } from "themes/default/breakpoints"

export default function StickerItem({
  textStyle,
  containerStyle,
  audioFile,
  image,
  message = "",
  sx,
  audioProps = {},
  imageStyle = 1,
  assignmentFromMessage = "",
}) {
  return (
    <Stack position={"relative"} sx={containerStyle}>
      {image &&
        (imageStyle === 2 ? (
          <img
            src={image}
            alt="Sticker"
            style={{
              width: "100%",
              height: "auto",
              objectFit: "contain",
              ...sx,
            }}
          />
        ) : (
          <ImageZoom
            src={image}
            alt="Sticker Preview"
            customStyle={sx}
            zoomEnabled={false}
          />
        ))}
      {audioFile && (
        <SoundButton
          absolute
          soundUrl={audioFile}
          interrupt
          customSx={{
            right: 0,
            top: 5,
            left: "unset",
          }}
          {...audioProps}
        />
      )}
      <Typography
        variant="span"
        sx={[
          {
            textAlign: "center",
            fontSize: 24,
            [masterBreakPoint]: { fontSize: 20 },
          },
          textStyle,
        ]}
      >
        {message}
      </Typography>
      {assignmentFromMessage?.trim()?.length > 0 && (
        <Typography
          variant="span"
          sx={[
            {
              textAlign: "center",
              fontSize: 24,
              [masterBreakPoint]: { fontSize: 20 },
            },
            textStyle,
          ]}
        >
          {`${assignmentFromMessage}`}
        </Typography>
      )}
    </Stack>
  )
}
